import { createContext, useContext, useReducer } from "react";
import { Outlet } from "react-router-dom";
import { CLOSE_TOAST, GlobalContextValue, GlobalState, GlobalStateAction, OPEN_TOAST, RESET_CURRENT_BUTTON, RESET_DATE, RESET_DATE_RANGE, RESET_EMAIL_SUBMITTED, RESET_JOB, RESET_SHIFT, SET_CURRENT_BUTTON, SET_DATE, SET_DATE_RANGE, SET_EMAIL_SUBMITTED, SET_JOB, SET_PREV_LOCATION, SET_SHIFT, defaultDate, defaultDateRange, defaultEmailSubmitted, defaultGlobalState, defaultJob, defaultShift, defaultToast } from "./GlobalProviderLayoutModel";

export const GlobalContext = createContext<GlobalContextValue>({
  state: defaultGlobalState,
  dispatch: () => { /** NOOP */ }
});

export const globalStateReducer = (state: GlobalState, action: GlobalStateAction) => {
  switch (action.type) {
    case OPEN_TOAST: return {
      ...state,
      toast: {
        ...state.toast,
        open: true,
        ...action.payload,
      }
    };
    case CLOSE_TOAST: return { ...state, toast: defaultToast };
    case SET_DATE_RANGE: return { ...state, dateRange: action.payload };
    case RESET_DATE_RANGE: return { ...state, dateRange: defaultDateRange };
    case SET_PREV_LOCATION: return { ...state, previousLocation: action.payload };
    case SET_DATE: return { ...state, dateValue: action.payload };
    case RESET_DATE: return { ...state, dateValue: defaultDate };
    case SET_SHIFT: return { ...state, shift: action.payload };
    case RESET_SHIFT: return { ...state, shift: defaultShift };
    case SET_JOB: return { ...state, job: action.payload };
    case RESET_JOB: return { ...state, job: defaultJob };
    case SET_EMAIL_SUBMITTED: return { ...state, emailSubmitted: action.payload };
    case RESET_EMAIL_SUBMITTED: return { ...state, emailSubmitted: defaultEmailSubmitted };
    case SET_CURRENT_BUTTON: return { ...state, button: action.payload };
    case RESET_CURRENT_BUTTON: return { ...state, button: null };
    default: return state;
  }
}

export const GlobalProviderLayout = () => {
  const [state, dispatch] = useReducer(globalStateReducer, defaultGlobalState);
  return <GlobalContext.Provider value={{ state, dispatch }}>
    <Outlet />
  </GlobalContext.Provider>
}

export const useGlobal = (): GlobalContextValue => {
  const context = useContext(GlobalContext);
  if (!context) throw new Error("GlobalContext context is undefined");
  return context;
};
